import React from 'react';
import { useParams } from 'react-router';
import { useProductGroup, useProductSections } from '@/features/constructorProducts/hooks';
import { Group } from '@/features/constructorCommon';

export const ProductGroup = ({groupProp, sectionId, onCreated}) => {
  const { id } = useParams();
  const {
    handleUpdate,
    handleDelete,
    handleCreate,
    isCreating,
    isUpdating,
    isDeleting
  } = useProductGroup({productId: id});
  const { dataSorted: dataSortedSections, loading: loadingSections, answers: dependentAnswers, setAnswers: setDependentAnswers } = useProductSections(id, groupProp ? groupProp.visibleConditions : null);

  return (
    <Group groupProp={groupProp} sectionId={sectionId} onCreated={onCreated}
           handleUpdate={handleUpdate}
           handleDelete={handleDelete}
           handleCreate={handleCreate}
           isCreating={isCreating}
           isUpdating={isUpdating}
           isDeleting={isDeleting}
           dataSortedSections={dataSortedSections}
           loadingSections={loadingSections}
           dependentAnswers={dependentAnswers}
           setDependentAnswers={setDependentAnswers}
           type="products"/>
  );
};
